import { QueryKeys } from "../../constants";

/**
 * This function stores the auth/access token in localstorage
 * @param {*} value
 */
const storeConfirmVoucherCallback = (value) => {
  localStorage.setItem(QueryKeys.CONFIRM_VOUCHER_CALLBACK, value);
};

/**
 * This function returns the stored auth/access token
 * @returns auth token
 */
const getConfirmVoucherCallback = () => {
  return localStorage.getItem(QueryKeys.CONFIRM_VOUCHER_CALLBACK);
};

const clearLocalStorage = () => {
  localStorage.clear();
};

/**
 * This function stores school details in local storage
 * @param {*} value
 */
const storeSchoolDetails = (value) => {
  sessionStorage.setItem(QueryKeys.SCHOOL, JSON.stringify(value));
};

/**
 * This function returns the school details stored in local storage
 * @returns
 */
const getSchoolDetails = () => {
  return JSON.parse(sessionStorage.getItem(QueryKeys.SCHOOL));
};

/**
 * This function stores school details in local storage
 * @param {*} value
 */
const storeStudentVoucherDetails = (value) => {
  localStorage.setItem(QueryKeys.STUDENT_VOUCHER, JSON.stringify(value));
};

/**
 * This function returns the school details stored in local storage
 * @returns
 */
const getStudentVoucherDetails = () => {
  return JSON.parse(localStorage.getItem(QueryKeys.STUDENT_VOUCHER));
};

/**
 * This function stores school details in local storage
 * @param {*} value
 */
const storeStudentDetails = (value) => {
  sessionStorage.setItem(QueryKeys.STUDENT, JSON.stringify(value));
};

/**
 * This function returns the school details stored in local storage
 * @returns
 */
const getStudentDetails = () => {
  return JSON.parse(sessionStorage.getItem(QueryKeys.STUDENT));
};

/**
 * This function stores student's addmission details like name and other personal information
 * @param {*} value
 */
const storeStudentAdmissionData = (value) => {
    sessionStorage.setItem(QueryKeys.ADMISSION_STATUS_STUDENT, JSON.stringify(value));
  };
  
  /**
   * This function returns the students admission details like name and other personal information
   * @returns
   */
  const getStudentAdmissionData = () => {
    return JSON.parse(sessionStorage.getItem(QueryKeys.ADMISSION_STATUS_STUDENT));
  };

  /**
 * This function stores school details in local storage
 * @param {*} value
 */
const storeSubmittedStudentDetails = (value) => {
    sessionStorage.setItem(QueryKeys.STUDENT, JSON.stringify(value));
  };
  
  /**
   * This function returns the school details stored in local storage
   * @returns
   */
  const getSubmittedStudentDetails = () => {
    return JSON.parse(sessionStorage.getItem(QueryKeys.STUDENT));
  };

export {
  storeConfirmVoucherCallback,
  getConfirmVoucherCallback,
  storeSchoolDetails,
  getSchoolDetails,
  storeStudentVoucherDetails,
  getStudentVoucherDetails,
  storeStudentDetails,
  getStudentDetails,
  storeStudentAdmissionData,
  getStudentAdmissionData,
  storeSubmittedStudentDetails,
  getSubmittedStudentDetails,
  clearLocalStorage,
};
